import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/shared/api';

import * as moment from 'moment';
moment.locale('de');

@Component({
	selector: 'dashboard-time-log',
	templateUrl: './time-log.component.html',
	styleUrls: ['./time-log.component.scss'],
})
export class TimeLogComponent implements OnInit {
	@Input() mode: string = 'content';
	@ViewChild('popover') popover;

	isIdOpen: number = null;
	idViewActiveBlock: number = null;

	projects: any[] = [];

	toolTip: string = '';

	statistics: any[] = [
		{
			name: 'Umsätze',
			data: 12000,
			olddata: 4000,
			sign: '€'
		},
		{
			name: 'Neue Käufer',
			data: 105,
			olddata: 80,
			sign: ''
		},
		{
			name: 'Anzahl der Besuche',
			data: 768,
			olddata: 1230,
			sign: ''
		},
		{
			name: 'Termin',
			data: 92,
			olddata: 89,
			sign: ''
		}
	]

	timerOn: string = '';
	constructor(private apiService: ApiService) { }

	ngOnInit() {
		this.getProjects();
	}

	toolTipT(toolTip) {
		if (this.toolTip === '') {
			this.toolTip = toolTip
		} else {
			this.toolTip = ''
		}
	}

	getProjects() {
		this.apiService.getProjects()
			.subscribe((projects: any) => {
				console.log(57, projects)
				for (let project of projects) {
					let totalMinutes = 0;
					for (let timeLog of project.timeLogs) {
						totalMinutes += timeLog.totalTime;
					}
					project.budgetPercent = 100 / (project.budgetMonthly / (totalMinutes / 60 * parseFloat(project.hourlyRate)));

				}


				this.projects = projects || [];
			});
	}
	addTimeLog(project, timeLog = null) {
		this.apiService.addTimeLog(project.id, timeLog ? timeLog.id : null, timeLog)
			.subscribe((timeLog: any) => {
				if (!timeLog.endTime) {
					timeLog.startTime = moment(timeLog.startTime).format();
					project.timeLog = timeLog;
				} else {
					this.isIdOpen = null;
					project.timeLog = null;
					this.getProjects();
					this.idViewActiveBlock = null;
				}

				console.log(69, timeLog);
			});
	}

	showTimer(timeLog) {
		if (!timeLog) {
			return '00:00:00'
		}
		return moment.utc(moment().diff(moment(timeLog.startTime))).format('HH:mm:ss');
	}

	presentPopover(e: Event, id, project) {
		project.timeLog.endTime = moment().format();

		this.isIdOpen = id;
		this.popover.event = e;
		this.idViewActiveBlock = id
	}

	// activeProject(i) {
	// 	if(this.idViewActiveBlock === null) {
	// 		this.idViewActiveBlock = i;
	// 	} else {
	// 		this.idViewActiveBlock = null;
	// 	}
	// }
}
